import { isValidSelector } from '@bizneo/core/utils';
import tippy from 'tippy.js';

const getTooltipPosition = (position) => {
  const validPosition = ['bottom', 'left', 'right'].includes(position);
  return {
    placement: validPosition ? position : 'top',
    popperOptions: validPosition
      ? {
          modifiers: [
            {
              name: 'flip',
              options: {
                fallbackPlacements: ['top', 'right'],
              },
            },
            {
              name: 'preventOverflow',
              options: {
                altAxis: true,
                tether: false,
              },
            },
          ],
        }
      : {},
  };
};
const underline = ($el) => !$el.is(".button, button, input[type='button'], .huge-icon");

function updateContent(instance, newContent) {
  if (newContent !== instance.props.content) {
    instance.setContent(newContent);
    $(instance.popper).trigger('dom-update', { source: 'tooltip' });
  }
}

function sanitizeTitle(str) {
  return str.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '');
}

function appendTooltip(element) {
  if (element.closest('.modal-dialog')) {
    return element.closest('.modal-dialog');
  }

  if (element.closest('.floating-menu')) {
    return element.closest('.floating-menu');
  }

  return document.body;
}

export function createTooltip(element, options) {
  return tippy(element, {
    content: options.title,
    theme: (options.size ? options.size : '') + (options.theme ? ` ${options.theme}` : ''),
    trigger: options.trigger ? options.trigger : 'mouseenter focus',
    onTrigger(instance, event) {
      event.preventDefault();
      event.stopPropagation();
    },
    allowHTML: true,
    appendTo: appendTooltip(element),
    aria: {
      content: 'describedby',
    },
    delay: options.delay ? options.delay : 200,
    maxWidth: options.size ? '100%' : 320,
    interactive: options.interactive || options.getFrom,
    ...getTooltipPosition(options.tooltip),
    onMount(instance) {
      if (!options.getFrom) return;
      if (isValidSelector(options.getFrom)) {
        updateContent(instance, $(options.getFrom).html());
      } else {
        $.ajax({
          url: options.getFrom,
          type: 'GET',
          success: (data) => {
            updateContent(instance, data);
          },
          error: (error) => console.error(error),
        });
      }
    },
    onShow() {
      const condition = $(element).data('tooltip-condition');
      if (condition && !$(element).is(condition)) {
        return false;
      }
    },
    onHide() {
      $(element).trigger('tooltip:close');
    },
  });
}

export default function mountTooltip(element) {
  const $element = $(element);
  const { type, title: dataTitle, ...options } = $element.data();
  const title = sanitizeTitle(dataTitle || $element.attr('title') || options.title || '');

  $element.removeAttr('title');

  if (title || options.getFrom) {
    switch (type) {
      case 'icon':
        return createTooltip(
          $('<span class="icon-info huge-icon huge-information-circle-stroke-standard is-xxsmall"></span>').appendTo(
            element
          )[0],
          { ...options, title }
        );

      case 'dot':
        $element.addClass('with-dot');
        return createTooltip(element, { ...options, title });

      case 'none':
        return createTooltip(element, { ...options, title });

      case 'underlined':
        $element.addClass('is-underlined');
        return createTooltip(element, { ...options, title });

      default:
        if (underline($element)) $element.addClass('is-underlined');
        return createTooltip(element, { ...options, title });
    }
  }
}
